import {
  PaymentMethod,
  PaymentSystem,
  TCardPaymentSystem,
} from 'modules/purchase/constants'

import { IAppState } from 'models/store.model'
import { IUpiPurchaseData, IUserStatus } from 'models/user.model'

import { TStepsVariant } from 'root-types'

export const selectUUID = (state: IAppState): string => state.user.uuid
export const selectExistingUUIDByEmail = (state: IAppState): string =>
  state.user.accountStatus.existingUuid
export const selectHasAccountByEmail = (state: IAppState): boolean | null =>
  state.user.accountStatus.hasAccount
export const selectHasAccessToAppByEmail = (state: IAppState): boolean | null =>
  state.user.accountStatus.hasAccessToApp
export const selectEmail = (state: IAppState): string =>
  state.user.status?.email?.onboardingEmail || ''
export const selectIsUserHasAccount = (state: IAppState): boolean =>
  state.user.status?.account.hasAccount || false
export const selectUserLoginEmail = (state: IAppState): string =>
  state.user.status?.account?.email || ''
export const selectOneLink = (state: IAppState): string => state.user.oneLink
export const selectLearnWorldsAutologinLink = (state: IAppState): string =>
  state.user.learnworldsLink
export const selectUserStatus = (state: IAppState): IUserStatus | null =>
  state.user.status
export const selectUserCountryCode = (state: IAppState): string =>
  state.common.appConfig?.countryCode || ''
export const selectUserGeoState = (state: IAppState): string =>
  state.user.status?.geoState || ''
export const selectUserPaymentCurrency = (state: IAppState): string =>
  state.user.status?.config.paymentCurrency || ''
export const selectUserPaymentMethod = (state: IAppState): PaymentMethod =>
  state.user.status?.config.paymentMethod || PaymentMethod.CREDIT_CARD
export const selectUserPaymentSystem = (state: IAppState): TCardPaymentSystem =>
  state.user.status?.config.paymentSystem || PaymentSystem.STRIPE
export const selectUserConfigData = (
  state: IAppState,
):
  | Record<
      string,
      | string
      | number
      | boolean
      | string[]
      | Record<string, string>
      | Record<string, number>
      | IUpiPurchaseData
      | null
    >
  | undefined => state.user.status?.config
export const selectUpiPurchaseData = (
  state: IAppState,
): IUpiPurchaseData | null => state.user.status?.config.upiPurchaseData || null
export const selectGeneralSubscriptionPrice = (state: IAppState): string =>
  state.user.status?.config.subscriptionPrice || ''
export const selectGeneralSubscriptionDuration = (state: IAppState): string =>
  state.user.status?.config.subscriptionDuration || ''
export const selectGeneralSubscriptionPriceId = (state: IAppState): string =>
  state.user.status?.config.priceId || ''
export const selectGeneralSubscriptionTrialPeriod = (
  state: IAppState,
): string => state.user.status?.config.trialPeriod || ''
export const selectGeneralSubscriptionTrialPrice = (state: IAppState): string =>
  state.user.status?.config.trialPrice || ''
export const selectIsDiscountApplied = (state: IAppState): boolean =>
  state.user.status?.config.isDiscountApplied || false
export const selectIsUserSignedUp = (state: IAppState): boolean =>
  state.user.status?.config?.isUserSignedUp || false
export const selectIsUserDeclinedUpsell = (state: IAppState): boolean =>
  state.user.status?.config?.isUserDeclinedUpsell || false
export const selectIsDiscountRevealApplied = (state: IAppState): boolean =>
  state.user.status?.config?.isDiscountRevealApplied || false
export const selectIsUserInAppAvailable = (state: IAppState): boolean =>
  state.user.status?.inapp?.isInAppAvailable || false
export const selectIsUserInAppPurchased = (state: IAppState): boolean =>
  state.user.status?.inapp?.isInAppPurchased || false
export const selectIsUserUpsellAvailable = (state: IAppState): boolean =>
  state.user.status?.upsell.isUpsellAvailable || false
export const selectIsUserUpsellPurchased = (state: IAppState): boolean =>
  state.user.status?.upsell.isUpsellPurchased || false
export const selectTestEnvironmentQueryParam = (state: IAppState): string =>
  state.user.testEnvironmentQueryParam
export const selectIsAccountCreationFlowPending = (state: IAppState): boolean =>
  state.user.isAccountCreationFlowPending
export const selectUserPaymentId = (state: IAppState): string =>
  state.user.status?.config.paymentId || ''
export const selectPrimerProcessorName = (state: IAppState): string =>
  state.user.status?.config.processorName || ''
export const selectStepsVariant = (
  state: IAppState,
): TStepsVariant | undefined => state.user.status?.config.stepsVariant
export const selectTimerEndTimes = (state: IAppState): Record<string, number> =>
  state.user.status?.config.timerEndTimes || {}
